import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-semibold" }
const _hoisted_2 = { class: "font-semibold" }
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Выберите причину опоздания из списка ниже.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createBlock(_component_new_modal, {
    title: `Укажите причину ${_ctx.stateId === 1 ? 'задержки отгрузки' : 'опоздания'} FTL заказа`,
    scrollable: "",
    loading: _ctx.isLoading,
    "transparent-header": "",
    onSubmit: _ctx.emitSubmit,
    onCancel: _ctx.emitCancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", null, [
        _createTextVNode(" FTL заказ № "),
        _createVNode(_component_router_link, {
          class: "text-blue-500 underline",
          to: _ctx.getLink,
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.ftlOrder.id), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createTextVNode(" по направлению "),
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.ftlOrder.stock_delivery_notes[0]?.directionName), 1),
        _createTextVNode(" должен был " + _toDisplayString(_ctx.stateId === 1 ? 'отгрузиться' : 'прибыть') + " ", 1),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.stateId === 1 ? _ctx.ftlOrder.date_of_load : _ctx.ftlOrder.date_of_unload), 1),
        _createTextVNode(". ")
      ]),
      _createElementVNode("p", null, [
        _createTextVNode(" Фактическая дата " + _toDisplayString(_ctx.stateId === 1 ? 'отгрузки' : 'прибытия') + ": ", 1),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.getTodayDate), 1),
        _createTextVNode(". ")
      ]),
      _hoisted_4,
      _createVNode(_component_new_select, {
        "can-deselect": "",
        class: "my-2",
        placeholder: "Выберите причину",
        loading: _ctx.data_state.comments.is_loading,
        failed: _ctx.data_state.comments.is_failed,
        disabled: _ctx.isLoading || _ctx.data_state.comments.is_loading,
        "search-without-refresh": "",
        options: _ctx.data_state.comments.list,
        value: _ctx.state.delayCommentId,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.delayCommentId) = $event)),
        "is-invalid": _ctx.state_form$.delayCommentId.$error,
        "validation-errors": _ctx.state_form$.delayCommentId.$errors,
        onRefresh: _ctx.loadComments
      }, null, 8, ["loading", "failed", "disabled", "options", "value", "is-invalid", "validation-errors", "onRefresh"])
    ]),
    _: 1
  }, 8, ["title", "loading", "onSubmit", "onCancel"]))
}